<template>
  <BRow class="book-editor-wrap">
    <ChapterList
        :chapters="chapters"
        :currentChapter="currentChapter"
        @setCurrentChapterId="setCurrentChapterId"
    />
    <BookContent
        :currentChapter="currentChapter"
    />
<!--    <TimestampList-->
<!--        :currentChapter="currentChapter"-->
<!--    />-->
  </BRow>
</template>

<script>
import ChapterList from "./ChapterList";
import BookContent from "./BookContent";
import TimestampList from "./TimestampList";

export default {
  name: "InfoBookComponent",
  components: {
    ChapterList,
    BookContent,
    TimestampList
  },
  props: {
    chapters: Array,
    currentChapter: Object
  },
  mounted() {
    if (this.$route.params.chapterId) {
      this.setCurrentChapterId(this.$route.params.chapterId);
    }
  },
  methods: {
    setCurrentChapterId(chapterId) {
      this.$emit('setCurrentChapterId', chapterId);
    }
  }
}
</script>
<style scoped>
.book-editor-wrap {
  height: 55vh;
}
</style>
